import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
const GetButton = ({ buttonInfo, variant, trackButtonClick, isMobileScreenSize, isLoading, }) => {
    const { label, url, target, type } = buttonInfo;
    return (React.createElement(TextButton, { variant: variant, href: url, target: target, "data-testid": `${type}-button-variant-${variant}`, "data-tracking-exclude": true, isFullWidth: isMobileScreenSize, isLoading: isLoading, onClick: () => {
            trackButtonClick(buttonInfo, variant, buttonInfo.trackingCode);
        }, size: dynamicStylingHelper('md', 'sm') }, label));
};
export default GetButton;
